import React from 'react';
import Bone from '@rental-manager/components/Bone';
import Page from '@common/components/Page';
import { Col, Container, Row } from '@zg-rentals/multibrand-ui/';

const SkeletonRows = () => (
  <>
    <Row>
      <Col>
        <Bone dark type="bar" className="Skeleton-bone-title" />
      </Col>
    </Row>

    <Row>
      <Col>
        <Bone dark type="line" className="Skeleton-bone-text-1" />
      </Col>
    </Row>

    <Row>
      <Col>
        <Bone dark type="line" className="Skeleton-bone-text-2" />
      </Col>
    </Row>

    <Row>
      <Col>
        <Bone dark type="line" className="Skeleton-bone-text-1" />
      </Col>
    </Row>
  </>
);

const Skeleton = () => (
  <Page noPadding className="PropertyDetailsPage">
    <Container className="Skeleton">
      <SkeletonRows />
      <SkeletonRows />
    </Container>
  </Page>
);

export default Skeleton;
